import React from 'react';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import { generateRegister } from '../utils';

interface FormCheckBoxProps extends ICommonFormProps {
    checked: boolean;
}

/**Form checkbox component */
const FormCheckBox = (props: FormCheckBoxProps) => {
    return (
        <FormControlLabel
            label={props?.formProps?.overrideJSXLabel || props.label}
            key={props.keyName}
            control={
                <Checkbox
                    {...props?.formProps?.checkboxProperties}
                    defaultChecked={props.value}
                    {...generateRegister(props)}
                    name={props.keyName}
                    key={props.keyName}
                    color={'primary'}
                    disabled={props.disabled}
                />
            }
        />
    );
};

export default FormCheckBox;
